import { requestTemplate } from 'api';

const getExternalAuth = () => requestTemplate.get(`/external-auth/`);

const addExternalAuth = (payload: any) => requestTemplate.post(`/external-auth/add/`, payload);

const deleteExternalAuth = (external_id: string) => requestTemplate.delete(`/external-auth/${external_id}/`);


const externalAuth = {
  getExternalAuth,
  addExternalAuth,
  deleteExternalAuth,
};

export default externalAuth;
